<template>
  <div class="ma-2">
    <v-btn-toggle
      v-model="excludeDynamic"
      dense
      group
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="exclude-dynamic-btn"
            :value="true"
            small
            v-bind="attrs"
            v-on="on">
            <v-icon>
              mdi-filter
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('videoconf.tooltip.excludeDynamic') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="include-dynamic-btn"
            :value="false"
            small
            v-bind="attrs"
            v-on="on">
            <v-icon>
              mdi-filter-off
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('videoconf.tooltip.includeDynamic') }}</span>
      </v-tooltip>
    </v-btn-toggle>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'videoconf-dynamic-filter',
  computed: {
    ...mapGetters({
      getExcludeDynamic: 'videoconfer/excludeDynamic'
    }),
    excludeDynamic: {
      get () {
        return this.getExcludeDynamic
      },
      set (value) {
        this.setExcludeDynamic(value)
      }
    }
  },
  methods: {
    ...mapActions({
      setExcludeDynamic: 'videoconfer/setExcludeDynamic'
    })
  }
}
</script>

<style scoped>
</style>
